import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Carousel, { Modal, ModalGateway } from 'react-images';

import { trackEvent } from '../helpers';

import { generateImageFromCDN } from '../helpers';
import { PopUpGallery } from './PhotoGallery';

const Wrapper = styled.section`
  margin-bottom: -90px;
  padding: 1em;
  padding-bottom: 120px;
  position: relative;
  z-index: 5;

  @media (max-width: 768px) {
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

const Img = styled.div`
  background: ${p => `url(${p.src}) center center no-repeat`};
  background-size: cover;
  display: block;
  max-width: 100%;
`;
const ImgGrid = styled.div`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: repeat(2, 200px);

  @media (max-width: 768px) {
    grid-gap: 10px;
    grid-template-rows: repeat(2, 90px);
  }

  ${Img} {
    box-sizing: border-box;
    cursor: pointer;
    max-height: 100%;
    outline: solid 6px transparent;
    outline-width: 6px;
    outline-offset: -6px;
    transition: outline .125s ease-in-out;

    &:hover {
      outline-color: #333;
      opacity: 0.9;
    }

    &:nth-child(1) {
      grid-row: 1 / 3;
    }
    &:nth-child(3) {
      position: relative;
      &:after {
        align-items: center;
        background: rgba(0,0,0,.6);
        color: #fff;
        content: "${p => `+ ${p.hiddenPhotosCount} more`}";
        display: flex;
        font-size: 32px;
        height: 100%;
        justify-content: center;
        left:0;
        position: absolute;
        top:0;
        width: 100%;

        @media (max-width: 768px) {
          font-size: 17px;
        }
      }
    }
  }
`;

export default function Images({ images, userId, vendorId }) {
  const renderingOnClient = typeof window !== 'undefined';
  // const [isMobile, setIsMobile] = useState(true);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  // useEffect(() => {
  //   setIsMobile(renderingOnClient && window.innerWidth < 789)
  // })

  const openLightbox = index => {
    setCurrentImage(index);
    setViewerIsOpen(true);
    trackEvent({ event: 'open-gallery', userId, vendorId });
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
    trackEvent({ event: 'close-gallery', userId, vendorId });
  };

  return (
    <Wrapper>
      {!!images.length && (
        <ImgGrid hiddenPhotosCount={images.length - 3 || ''}>
          {images.slice(0, 3).map((img, index) => {
            return (
              <Img
                src={generateImageFromCDN(img.src)}
                onClick={openLightbox.bind(this, index)}
                key={index}
              />
            );
          })}
        </ImgGrid>
      )}
      <PopUpGallery
        viewerIsOpen={viewerIsOpen}
        closeLightbox={closeLightbox}
        currentImage={currentImage}
        images={images}
      />
    </Wrapper>
  );
}
